// Section for import npm components ------------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------
// import { AppConfigContext } from '@providers/AppConfigProvider';
import ComprehensiveEvaluation from '@components/MansionDetail/ComprehensiveEvaluation';
import ReviewCategoryContainer from '@components/MansionDetail/MansionReview/ReviewCategoryContainer';
import MansionReviewProvider, {
  MansionReviewContext,
} from '@providers/MansionDetail/MansionReview/MansionReviewProvider';

// import CommonUtility from '@utils/Common';

// Section for type definition -----------------------------------------------------------------------------------------
// import CommonUtilityClass from '@/types/CommonUtilityClass';
import MansionReviewPropsData from '@/types/components/MansionDetail/MansionReviewPropsData';

type MansionReviewProps = {
  mansionReview: MansionReviewPropsData;
};

// const commonUtil: CommonUtilityClass = CommonUtility;

export default function MansionReview(props: MansionReviewProps): React.JSX.Element {
  const { mansionReview } = props;
  useContext(MansionReviewContext);
  return (
    <Box id="section-mansion-review" className="md:max-w-7xl md:w-full md:mx-auto md:px-24 mb-16 max-md:mb-12">
      <MansionReviewProvider mansionReview={{ mansionReview }}>
        <Typography
          variant="h2"
          className="max-md:mx-5 mb-6 max-md:mb-8 pl-4 border-solid border-l-2 border-rf-black relative text-lg font-bold before:absolute before:top-1 before:left-[-16px] max-md:before:left-0"
        >
          口コミ情報
        </Typography>
        <ComprehensiveEvaluation />
        <ReviewCategoryContainer category="LivingEnvironment" />
        <ReviewCategoryContainer category="exteriorAndFacilities" />
        <ReviewCategoryContainer category="roomFacilities" />
        <ReviewCategoryContainer category="shoppingAndEating" />
        <ReviewCategoryContainer category="convenientLiving" />
        <ReviewCategoryContainer category="convenientTransportation" />
        <ReviewCategoryContainer category="hope" />
        <Box className="rf-mansion-review max-md:px-5">
          <Typography className="text-2xs mr-1">※</Typography>
          <Typography className="text-2xs">
            口コミは
            <Link
              href="https://www.mansion-review.jp/"
              underline="none"
              className="text-rf-blue font-bold underline"
              target="_blank"
            >
              マンションレビュー
            </Link>
            より提供されており、投稿時点における主観的なご意見です。内容の真偽は保証しかねますのでご了承ください。
          </Typography>
        </Box>
      </MansionReviewProvider>
    </Box>
  );
}
